module.exports = __webpack_public_path__ + "media/src/images/icons/file_new-36e839679dabaff5226387586015597c.svg";